import { Controller } from "@hotwired/stimulus"

// Scrolls to top of the page when connected
// Useful for flash messages after Turbo Stream updates
export default class extends Controller {
  connect() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
